// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"b89f2894","261":"70ef5e07","429":"7a233755","687":"48dbd4e5","961":"8057cb5f"}[chunkId] + ".chunk.js";
};